/**
 * Task 3.8 — Escalate-mode payload composer.
 *
 * Maps the drawer's local `selectedMap` to the API_CONTRACT
 * `EscalateTicketInput` shape. Per locked decision #4 in the PRD,
 * already-escalated members are intentionally NEVER inserted into
 * `selectedMap` in escalate mode (see `AssignTeammatesDrawer.toggleSelection`
 * — disabled-selected rows have `onToggle === undefined`), so they are
 * naturally excluded here without an explicit filter.
 *
 * `note` is locked to `""` for v1 — no textarea on the drawer per PRD
 * §"Escalate drawer". Backend accepts the empty string.
 */

import type {
  EscalateTicketInput,
  EscalateTicketMemberInput,
  EscalateTicketScheduleSlot,
} from "shared/types/escalations";
import type { SelectedMemberEntry } from "../types";

export const buildEscalatePayload = (
  selectedMap: Map<string, SelectedMemberEntry>,
  note: string = "",
): EscalateTicketInput => {
  const members: EscalateTicketMemberInput[] = [];

  for (const entry of selectedMap.values()) {
    const scheduleTimes: EscalateTicketScheduleSlot[] = entry.timeSlots
      .filter(
        (slot): slot is typeof slot & { startIso: string; endIso: string } =>
          slot.startIso !== null && slot.endIso !== null,
      )
      .map((slot) => ({
        start_time: slot.startIso,
        end_time: slot.endIso,
      }));

    members.push({
      resource_id: entry.resource.mapping_id,
      schedule_times: scheduleTimes,
    });
  }

  return { members, note };
};
